const QUICK_ATC_SELECTOR = "[data-quick-atc-form]";

// Capture submit as early as possible to prevent native form redirects
document.addEventListener(
  "submit",
  async (event) => {
    const form = event.target.closest(QUICK_ATC_SELECTOR);
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (form.dataset.quickAtcLoading === "true") {
      return;
    }

    const submitButton = form.querySelector("button[type='submit']");

    try {
      form.dataset.quickAtcLoading = "true";
      if (submitButton) {
        submitButton.classList.add("is-loading");
        submitButton.setAttribute("aria-busy", "true");
      }

      const formData = new FormData(form);
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Unable to add to cart");
      }

      // Fire custom event so other components can respond
      document.dispatchEvent(
        new CustomEvent("quickAtc:added", {
          detail: { form },
        })
      );

      if (typeof openCartDrawer === "function") {
        openCartDrawer(true);
      }
    } catch (error) {
      console.error("Quick add to cart failed", error);
      document.dispatchEvent(
        new CustomEvent("quickAtc:error", {
          detail: {
            form,
            message: error.message,
          },
        })
      );
    } finally {
      delete form.dataset.quickAtcLoading;
      if (submitButton) {
        submitButton.classList.remove("is-loading");
        submitButton.removeAttribute("aria-busy");
      }
    }
  },
  true
);
